import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Card,
  Grid,
  CardContent,
  Typography,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  statsItem: {
    alignItems: 'center',
    display: 'flex'
  },
  statsIcon: {
    marginRight: theme.spacing(1)
  },
  avatar: {
    width: 'auto',
    height: 'auto'
  }
}));

const CouponCardPreview = ({
  className, coupon, ...rest
}) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid container spacing={1}>
          <Grid container item xs={3} direction="column" justify="center" alignItems="center">
            <Avatar
              className={classes.avatar}
              alt="banner"
              src="https://e7.pngegg.com/pngimages/110/471/png-clipart-discounts-and-allowances-advertising-sales-promotion-computer-icons-marketing-logo-discount-thumbnail.png"
              variant="square"
            />
          </Grid>
          <Grid item xs={9}>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="h4"
            >
              {coupon?.title}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
            >
              {coupon?.description}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
            >
              {coupon?.key}
            </Typography>
            <Typography
              align="left"
              color="textPrimary"
              gutterBottom
              variant="caption"
            >
              {coupon?.value}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

CouponCardPreview.propTypes = {
  className: PropTypes.string,
  coupon: PropTypes.object,
};

CouponCardPreview.defaultProps = {
  className: '',
  coupon: {},
};

export default CouponCardPreview;
